"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VersionService = function VersionService($http, $rootScope) {
  var VERSION_CHECK_INTERVAL_IN_MS = 5 * 60 * 1000; // 5 minutes
  var VERSION_CHECK_WITH_SERVER_AFTER = 3 * 60 * 60 * 1000; // 3 hours
  var versionUrl = WEBSERVICEURL + "/dataagility/api/service.version";

  function ensureVersionMatchWithServerLoop() {
    // Check localstorage
    if (shouldCheckForNewVersion()) {
      var lastVersion = localStorage.getItem("lastVersion");

      getVersionFromServer().then(function (res) {
        localStorage.setItem("lastVersionCheckedAt", Date.now() + "");
        localStorage.setItem("lastVersion", res.version);

        if (lastVersion != null && res.version != lastVersion) {
          localStorage.setItem("lastVersionReload", Date.now() + "");
          window.location.reload();
        }
      });
    }

    setTimeout(function () {
      ensureVersionMatchWithServerLoop();
    }, VERSION_CHECK_INTERVAL_IN_MS);
  }

  function getVersionFromServer() {
    return $http.get(versionUrl).then(function (res) {
      return res.data;
    });
  }

  function shouldCheckForNewVersion() {
    var lastVersionCheckedAt = localStorage.getItem("lastVersionCheckedAt");
    if (lastVersionCheckedAt == null) {
      return true;
    }

    if (Date.now() - Number(lastVersionCheckedAt) > VERSION_CHECK_WITH_SERVER_AFTER) {
      return true;
    }

    return false;
  }

  return {
    ensureVersionMatchWithServerLoop: ensureVersionMatchWithServerLoop
  };
};

exports.default = VersionService;


// WEBPACK FOOTER //
// ./client/app/common/services/version.service.js